<template>
    <Dialog v-model:open="open" v-if="canCreate">
        <DialogTrigger as-child>
            <slot />
        </DialogTrigger>
        <DialogContent class="sm:max-w-[425px]">
            <DialogHeader>
                <template #icon>
                    <PlusIcon
                        class="text-z-primary-600"
                        stroke-width="2.25"
                        :size="20"
                    />
                </template>

                <DialogTitle> {{ $t("teams.new_team") }}</DialogTitle>
                <DialogDescription>
                    {{ $t("teams.new_team_description") }}
                </DialogDescription>
            </DialogHeader>
            <form @submit.prevent="createTeam">
                <div class="gap-4 py-4 grid">
                    <div class="max-w-sm gap-1.5 grid w-full items-center">
                        <Label for="domain">{{ $t("teams.team_name") }}</Label>
                        <Input id="name" v-model="name" type="text" />
                    </div>
                </div>
                <DialogFooter>
                    <ZButton class="ml-4" type="submit">
                        {{ $t("create") }}
                    </ZButton>
                </DialogFooter>
            </form>
        </DialogContent>
    </Dialog>

    <!-- Show disabled state with explanation when user can't create teams -->
    <TooltipProvider v-else>
        <Tooltip>
            <TooltipTrigger as-child>
                <div>
                    <slot />
                </div>
            </TooltipTrigger>
            <TooltipContent class="max-w-xs">
                <div class="space-y-1">
                    <p class="font-semibold">
                        {{ $t("teams.subscription_required.title") }}
                    </p>
                    <p class="text-sm text-muted-foreground">
                        {{ $t("teams.subscription_required.description") }}
                    </p>
                </div>
            </TooltipContent>
        </Tooltip>
    </TooltipProvider>
</template>

<script lang="ts" setup>
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
    DialogDescription,
} from "@/components/ui/dialog";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip";
import ZButton from "../../Atomic/Button.vue";
import { ref } from "vue";
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";
import { PlusIcon } from "lucide-vue-next";

const props = defineProps<{
    defalutOpen?: boolean;
    canCreate?: boolean;
}>();

const open = ref(props.defalutOpen ?? (false && (props.canCreate ?? true)));
const name = ref("");

async function createTeam() {
    router.post(
        route("app.teams.store"),
        {
            name: name.value,
        },
        {
            onFinish: () => {
                open.value = false;
            },
        },
    );
}
</script>
